import { Close } from "@mui/icons-material";
import { Grid, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { ReactElement } from "react";

const Container = styled(Grid)(({ theme }) => ({
    display: "flex",
    background: theme.palette.background.paper,
    marginBottom: theme.spacing(3),
    borderRadius: 5,
    overflow: "hidden",
}));

const HeaderContainer = styled(Grid)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    background: theme.palette.primary.main,
    padding: theme.spacing(0.3),
    minHeight: 35, // Ensure consistent height
}));

const ItemContent = styled(Grid)(({ theme }) => ({
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.getContrastText(theme.palette.primary.main),
}));

export interface WindowGridContainerProps {
    title: string;
    onClosed?: () => void;
}

export function WindowGridContainer(props: React.PropsWithChildren<WindowGridContainerProps>): ReactElement {


    const handleClose = () => {
        if (props.onClosed) {
          props.onClosed();
        }
    };

    
    return (
        <Container container spacing={0} direction="row">
            <HeaderContainer size={12} container direction="row" alignItems="center">
                <Grid size="grow"></Grid>
                <Grid>
                    <StyledTypography variant="h6">
                        {props.title}
                    </StyledTypography>
                </Grid>
                <Grid size="grow" container justifyContent="flex-end">
                    {props.onClosed &&
                    <IconButton size="small" onClick={handleClose}>
                        <Close />
                    </IconButton>
                    }
                </Grid>
            </HeaderContainer>

            <ItemContent size={12} container spacing={0} alignItems="center" justifyContent="space-around">
                {props.children}
            </ItemContent>

            <Grid size={12}></Grid>
        </Container>
    );
}
